<template>
  <div class="now-result">
    <h2>ງວດປະຈຳວັນທີ່ {{ lottoDate | date }}</h2>
    <h1>
      <EmptyNumbers v-if="status===0" />
      <SpinNumbers v-else-if="status===1" :startShow="startShow" :resultNumbers="resultNumbers" />
      <ShowSuccessResult v-else-if="status===2" :resultNumbers="resultNumbers" />
    </h1>
    <h3>ເວລາອອກເລກ {{showTime}}</h3>
    <table class="table table-bordered">
      <tr>
        <td>ເລກ 5 ໂຕ</td>
        <td>{{ Digit5 }}</td>
      </tr>
      <tr>
        <td>ເລກ 4 ໂຕ</td>
        <td>{{ Digit4 }}</td>
      </tr>
      <tr>
        <td>ເລກ 3 ໂຕ</td>
        <td>{{ Digit3 }}</td>
      </tr>
      <tr>
        <td>ເລກ 2 ໂຕ</td>
        <td>{{ Digit2Top }}</td>
      </tr>
      <tr>
        <td>ເລກ 1 ໂຕ</td>
        <td>{{ Digit1 }}</td>
      </tr>
      <tr>
        <td style="border-top: 3px solid #bbb;">ເລກ 2 ພິເສດ</td>
        <td style="border-top: 3px solid #bbb;">{{ Digit2Special }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
import moment from "@/moment"

import LottoService from "@/services/lottoService"

import EmptyNumbers from './EmptyNumbers.vue'
import SpinNumbers from './SpinNumbers.vue'
import ShowSuccessResult from './ShowSuccessResult.vue'

export default {
  name: 'TodayResult',
  components: {
    EmptyNumbers,
    SpinNumbers,
    ShowSuccessResult
  },
  data() {
    return {
      data: null,
      status: 0,
      Interval: null,
      setTimeout: null
    }
  },
  computed: {
    lottoDate() {
      if (this.data) {
        return this.data.lotto_date
      } else {
        return ''
      }
    },
    startShow() {
      if (this.data) {
        return this.data.show_result
      } else {
        return null
      }
    },
    resultNumbers() {
      if (this.results) {
        return this.results.digit5
      } else {
        return null
      }
    },
    results() {
      if (this.data) {
        return this.data.results
      } else {
        return null
      }
    },
    Digit5() {
      if (this.results && this.status === 2) {
        return this.results.digit5
      } else {
        return '-----'
      }
    },
    Digit4() {
      if (this.results && this.status === 2) {
        return this.results.digit4
      } else {
        return '----'
      }
    },
    Digit3() {
      if (this.results && this.status === 2) {
        return this.results.digit3
      } else {
        return '---'
      }
    },
    Digit2Top() {
      if (this.results && this.status === 2) {
        return this.results.digit2_top
      } else {
        return '--'
      }
    },
    Digit1() {
      if (this.results && this.status === 2) {
        return this.results.digit1
      } else {
        return '-'
      }
    },
    Digit2Bottom() {
      if (this.results && this.status === 2) {
        return this.results.digit2_bottom
      } else {
        return '--'
      }
    },
    Digit2Special() {
      if (this.results && this.status === 2) {
        return this.results.digit2_special
      } else {
        return '--'
      }
    },
    showTime() {
      if (this.results) {
        return moment(this.data.show_result).format("HH:mm")
      } else {
        return '--'
      }
    }
  },
  methods: {
    loadResult() {
      LottoService.nowResult().then((response) => {
        if (response.status === 'success') {
          this.data = response.data
          this.calProcess()
        }
      })
    },
    calProcess() {
      let successTime = moment(this.data.show_result).add(1, 'seconds')
      // ยังไม่ถึงเวลาเริ่มหมุน
      if (moment().isBefore(this.data.start_spin)) {
        this.status = 0
        clearTimeout(this.setTimeout)
        let diff = moment(this.data.start_spin).diff(moment(), 'milliseconds') + 1000
        this.setTimeout = setTimeout(() => {
          this.calProcess()
        }, diff)
      } else
        // อยู่ระหว่างหมุนออกรางวัล
        if (this.data.start_spin && this.data.show_result && moment().isBetween(this.data.start_spin, successTime)) {
          this.status = 1
          clearTimeout(this.setTimeout)
          let diff = moment(this.data.show_result).diff(moment(), 'milliseconds') + 1000
          this.setTimeout = setTimeout(() => {
            this.calProcess()
          }, diff)
        } else
          // กำลังหมุนออกรางวัล แต่ไม่ได้ตั้งเวลาออกผล
          if (moment().isAfter(this.data.start_spin) && !this.data.show_result) {
            this.status = 1
          } else
            // ถึงเวลาออกผลแล้ว
            if (moment().isAfter(this.data.show_result)) {

              let results = this.data.results
              if (results.digit5) {
                // ออกผลเสร็จหมดแล้ว
                if (moment().isAfter(successTime)) {
                  this.status = 2
                } else {
                  // กำลังอยู่ในขั้นตอนแสดงผลที่ล่ะชุดตัวเลข
                  let diff = moment(successTime).diff(moment(), 'milliseconds') + 500
                  this.setTimeout = setTimeout(() => {
                    this.calProcess()
                  }, diff)
                }
                // เลยเวลาออกผล แต่ไม่มีผลมา
              } else {
                this.status = 1
                clearTimeout(this.setTimeout)
                this.setTimeout = setTimeout(() => {
                  this.loadResult()
                }, 10000)
              }

            }
    }
  },
  created() {
    this.loadResult()
    this.Interval = setInterval(() => {
      this.loadResult()
    }, 60000)
  },
  filters: {
    date(param) {
      if (param) {
        return moment(param).format("LL")
      } else {
        return '-'
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.Interval)
    clearTimeout(this.setTimeout)
  }
}

</script>
